/* Perfume Australia – wishlist.
 * Saved product handles are kept in this browser (localStorage).
 * Hearts: any element with [data-pa-wish][data-handle].
 * Header icon is added next to the cart; page lives at /search?view=wishlist.
 */
(function () {
  'use strict';

  var KEY = 'pa_wishlist_v1';
  var MAX = 100;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var PAGE_URL = root + 'search?view=wishlist';
  var HEART = '<svg class="pa-heart-svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path class="pa-heart" d="M12 20.25c-.3 0-7.6-4.45-9.35-9.05C1.4 7.9 3.45 4.5 7 4.5c2.05 0 3.6 1.15 5 2.95 1.4-1.8 2.95-2.95 5-2.95 3.55 0 5.6 3.4 4.35 6.7-1.75 4.6-9.05 9.05-9.35 9.05z" stroke-linejoin="round" stroke-linecap="round"/></svg>';

  function read() {
    try {
      var v = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) {
      return [];
    }
  }

  function write(items) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(items.slice(0, MAX)));
    } catch (e) {}
  }

  var list = read();

  function has(handle) {
    return list.indexOf(handle) !== -1;
  }

  function syncButtons() {
    document.querySelectorAll('[data-pa-wish]').forEach(function (btn) {
      var on = has(btn.getAttribute('data-handle'));
      if (btn.classList.contains('is-active') !== on) btn.classList.toggle('is-active', on);
      var pressed = on ? 'true' : 'false';
      if (btn.getAttribute('aria-pressed') !== pressed) btn.setAttribute('aria-pressed', pressed);
      btn.querySelectorAll('[data-pa-wish-label]').forEach(function (label) {
        var text = on ? label.getAttribute('data-on') : label.getAttribute('data-off');
        if (text && label.textContent !== text) label.textContent = text;
      });
      var aria = on ? btn.getAttribute('data-aria-on') : btn.getAttribute('data-aria-off');
      if (aria && btn.getAttribute('aria-label') !== aria) btn.setAttribute('aria-label', aria);
    });
    var count = String(list.length);
    document.querySelectorAll('[data-pa-wish-count]').forEach(function (el) {
      if (el.textContent !== count) el.textContent = count;
      var hide = list.length === 0;
      if (el.hidden !== hide) el.hidden = hide;
    });
  }

  function ensureHeaderIcon() {
    var right = document.querySelector('.header__right');
    if (!right || right.querySelector('.pa-wish-header')) return;
    var link = document.createElement('a');
    link.className = 'header__icon pa-wish-header focus-inset';
    link.href = PAGE_URL;
    link.setAttribute('aria-label', 'Wishlist');
    link.innerHTML = HEART + '<span class="pa-wish-header__count" data-pa-wish-count hidden>0</span>';
    var node = document.getElementById('cart-icon-bubble');
    while (node && node.parentElement !== right) node = node.parentElement;
    if (node) right.insertBefore(link, node);
    else right.appendChild(link);
  }

  var toastTimer;
  function toast(added) {
    var t = document.querySelector('.pa-wish-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'pa-wish-toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      document.body.appendChild(t);
    }
    t.innerHTML = added
      ? '<span>Saved to your wishlist</span><a href="' + PAGE_URL + '">View wishlist</a>'
      : '<span>Removed from your wishlist</span>';
    t.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      t.classList.remove('is-visible');
    }, 2600);
  }

  function toggle(handle) {
    list = read();
    var added;
    if (has(handle)) {
      list = list.filter(function (h) { return h !== handle; });
      added = false;
    } else {
      list.unshift(handle);
      added = true;
    }
    write(list);
    syncButtons();
    document.dispatchEvent(new CustomEvent('pa:wishlist:change', { detail: { handle: handle, added: added, count: list.length } }));
    if (!document.querySelector('[data-pa-wishlist-page]')) toast(added);
  }

  document.addEventListener('click', function (event) {
    var btn = event.target && event.target.closest ? event.target.closest('[data-pa-wish]') : null;
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    var handle = btn.getAttribute('data-handle');
    if (!handle) return;
    toggle(handle);
    btn.classList.remove('is-pop');
    void btn.offsetWidth;
    btn.classList.add('is-pop');
  }, true);

  /* ---------- Wishlist page ---------- */

  function updateTotal(page) {
    var el = page.querySelector('[data-pa-wishlist-total]');
    if (!el) return;
    var n = list.length;
    var txt = n === 0 ? '' : (n === 1 ? '1 fragrance' : n + ' fragrances');
    if (el.textContent !== txt) el.textContent = txt;
  }

  function renderPage() {
    var page = document.querySelector('[data-pa-wishlist-page]');
    if (!page || page.getAttribute('data-rendered') === 'true') return;
    page.setAttribute('data-rendered', 'true');
    var grid = page.querySelector('[data-pa-wishlist-grid]');
    var empty = page.querySelector('[data-pa-wishlist-empty]');
    var loading = page.querySelector('[data-pa-wishlist-loading]');
    list = read();
    updateTotal(page);
    if (!list.length) {
      if (loading) loading.hidden = true;
      empty.hidden = false;
      return;
    }
    var handles = list.slice();
    Promise.all(handles.map(function (h) {
      return fetch(root + 'products/' + encodeURIComponent(h) + '?section_id=pa-wishlist-card', { credentials: 'same-origin' })
        .then(function (r) {
          if (r.status === 404) return { h: h, gone: true };
          return r.ok ? r.text().then(function (t) { return { h: h, html: t }; }) : { h: h };
        })
        .catch(function () { return { h: h }; });
    })).then(function (results) {
      var gone = [];
      var frag = document.createDocumentFragment();
      results.forEach(function (res) {
        if (res.gone) { gone.push(res.h); return; }
        if (!res.html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = res.html;
        var card = tmp.querySelector('.pa-card');
        if (!card) return;
        var li = document.createElement('li');
        li.className = 'flex-grid__item';
        li.setAttribute('data-handle', res.h);
        li.appendChild(card);
        frag.appendChild(li);
      });
      if (gone.length) {
        list = read().filter(function (h) { return gone.indexOf(h) === -1; });
        write(list);
      }
      grid.innerHTML = '';
      grid.appendChild(frag);
      if (loading) loading.hidden = true;
      empty.hidden = grid.children.length > 0;
      updateTotal(page);
      syncButtons();
    });
  }

  document.addEventListener('pa:wishlist:change', function (event) {
    var page = document.querySelector('[data-pa-wishlist-page]');
    if (!page) return;
    var grid = page.querySelector('[data-pa-wishlist-grid]');
    var empty = page.querySelector('[data-pa-wishlist-empty]');
    if (!event.detail.added) {
      var items = grid.querySelectorAll('li[data-handle]');
      for (var i = 0; i < items.length; i++) {
        if (items[i].getAttribute('data-handle') === event.detail.handle) {
          var li = items[i];
          li.classList.add('is-removing');
          setTimeout(function () {
            li.remove();
            empty.hidden = grid.children.length > 0;
          }, 250);
          break;
        }
      }
    }
    updateTotal(page);
  });

  /* ---------- Init ---------- */

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      ensureHeaderIcon();
      syncButtons();
    });
  }

  function init() {
    ensureHeaderIcon();
    syncButtons();
    renderPage();
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) { schedule(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('storage', function (event) {
      if (event.key === KEY) { list = read(); syncButtons(); }
    });
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) { list = read(); syncButtons(); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
